// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {UserJoinedDate} from './UserJoinedCell'
import {User} from '../../core/_models'
import { UserStatuCell ,EmbeddingStatusCell} from './UserStatusCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='File Name' className='min-w-125px' />,
    id: 'fileName',
    Cell: ({...props}) => <UserInfoCell embeddings={props.data[props.row.index]} />,
  },
  
  
  { id : 'active',
    Header: (props) => <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />,
    Cell: ({...props}) => <UserStatuCell embedding={props.data[props.row.index]} />,
  },

 

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Uploaded Date' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({...props}) => <UserJoinedDate embeddings={props.data[props.row.index]} />,
  },
  
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} status={props.data[props.row.index].status} 
    embedding={props.data[props.row.index]}
    />,
  },
]

export {usersColumns}
